import { FormFieldTypes } from "../../../data/formFieldType";

export const DiscontinueApplicationdata = {
    name: "DiscontinueReason",
    initialState: {
        discontinueReasonId: null,
        otherDiscontinuedReason: null,
        internalComments: "",
    },
    formFields: [
        {
            id: "discontinueReasonId",
            lable: "Discontinuation Reason",
            Field_Name: "Discontinuation Reason",
            fieldType: FormFieldTypes.SELECT,
            dataField: "discontinueReasonId",
            fieldSetting: {
                placeholder: "",
                options: [],
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-lg-6 mb-3",
            },
        },
        {
            id: "otherDiscontinuedReason",
            lable: "Others Discontinued Reason",
            Field_Name: "Others Discontinued Reason",
            fieldType: FormFieldTypes.TEXTAREA,
            dataField: "otherDiscontinuedReason",
            fieldSetting: {
                placeholder: "",
                isDisable: false,
            },
            validation: [],
            style: {
                containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-2 mb-3 d-none",
            },
        },
        {
            id: "internalComments",
            lable: "Internal Comments",
            Field_Name: "Internal Comments",
            fieldType: FormFieldTypes.TEXTAREA,
            dataField: "internalComments",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-lg-6 mb-3 d-none",
            },
        },
    ]   
}